import { restApi } from "@/api";
import { ACTIONABLE_TYPES } from "@/constants";

export const commitLike = (
  { actionable_id, actionable_type, fromBoosted, comment = "" } = {
    fromBoosted: false,
  }
) => {
  return restApi.post("actions/like", {
    actionable_id: actionable_id,
    actionable_type: actionable_type,
    comment: comment,
    from_boosted: fromBoosted,
  });
};

export const commitDislike = ({ userId, fromBoosted } = { fromBoosted: false }) => {
  return restApi.post("actions/dislike", {
    actionable_id: userId,
    actionable_type: ACTIONABLE_TYPES.USER,
    from_boosted: fromBoosted,
  });
};

export const commitReport = ({ userId, fromBoosted } = { fromBoosted: false }) => {
  return restApi.post("actions/report", {
    actionable_id: userId,
    actionable_type: ACTIONABLE_TYPES.USER,
    from_boosted: fromBoosted,
  });
};
